import React, { useContext, useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom';
import { GlobalState } from '../../../../GlobalState';
import { TabTitle } from '../../../../util/titleChanger'
import { api } from '../../../../util/urlConfig';
import './supplierview.css'

function SupplierView() {
    TabTitle('View Supplier');
    const { supplierId } = useParams();
    const state = useContext(GlobalState)

    const [supplierDetail] = state.supplierAPI.supplierDetail;
    const [users] = state.userAPI.users;
    const [id, setId] = state.supplierAPI.id;

    const [values, setValues] = useState('')

    useEffect(() => {
        if (supplierId > 0) {
            setId(supplierId);
            var today = new Date();
            var dob = new Date(supplierDetail.dob);

            var createAt = new Date(supplierDetail.created_at);
            var createBy = users.data && supplierDetail.created_by ? users.data.find(user => {
                return user.nic === supplierDetail.created_by.nic
            }) : ""

            setValues({
                ...values,
                supplier_code: supplierDetail.supplier_code ? supplierDetail.supplier_code : "",
                first_name: supplierDetail.first_name ? supplierDetail.first_name : "",
                last_name: supplierDetail.last_name ? supplierDetail.last_name : "",
                contact_no: supplierDetail.contact_no ? supplierDetail.contact_no : "",
                dob: supplierDetail.dob ? dob.toLocaleDateString('ja-JP') : today.toLocaleDateString('ja-JP'),
                nic: supplierDetail.nic ? supplierDetail.nic : "",
                email: supplierDetail.email ? supplierDetail.email : "",
                address1: supplierDetail.address1 ? supplierDetail.address1 : "",
                address2: supplierDetail.address2 ? supplierDetail.address2 : "",
                address3: supplierDetail.address3 ? supplierDetail.address3 : "",
                village: supplierDetail.village ? supplierDetail.village : "",
                city: supplierDetail.city ? supplierDetail.city : "",
                country: supplierDetail.country ? supplierDetail.country : "",
                created_at: supplierDetail.created_at ? createAt.toLocaleDateString('ja-JP') : today.toLocaleDateString('ja-JP'),
                created_by: supplierDetail.created_by ? createBy : { first_name: "", last_name: "" },
                image_url: supplierDetail.upload_image ? supplierDetail.upload_image.image_url : '/img/dummy_avatar.png'
            })
        }
    }, [id, supplierId, supplierDetail])

    return (
        <div className="profile-main-container">
            <div className="profile-container">
                <div className="left-container">
                    <img src={api + "/" + values.image_url} alt="avatar" />
                </div>
                <div className='right-container'>
                    <div className="action">
                        <Link to={`/supplier-form/${id}`}><i className="uil uil-pen"></i><button></button></Link>
                    </div>
                    <div className="name-title">
                        <h2>{values.first_name + " " + values.last_name}</h2>
                        <p>{values.supplier_code}</p>
                    </div>
                    <div className="user-content">
                        <p>DOB : <span>{values.dob}</span></p>
                        <p>Email : <span>{values.email}</span></p>
                        <p className='status'>Created By : <span>{values.created_by ? values.created_by.first_name : ""} {values.created_by ? values.created_by.last_name : ""}</span></p>
                        <p>NIC : <span>{values.nic}</span></p>
                        <p>Contact No : <span>{values.contact_no}</span></p>
                        <p>Created At : <span>{values.created_at}</span></p>
                        <p>Address : <span>{values.address1 + ", " + values.address2 + ", " + values.address3 + ", "}<br />
                            {values.village + ", " + values.city}</span></p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SupplierView